import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const LINKS = [{
  label: 'Shop',
  href: '/#packages'
}, {
  label: 'About Us',
  href: '/about'
}, {
  label: 'Ingredients',
  href: '/ingredients'
}];
export function Navbar() {
  const [open, setOpen] = useState(false);
  return <motion.header initial={{
    y: -80
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className="fixed inset-x-0 top-0 z-50 border-b border-forest/10 bg-ivory text-forest" data-id="element-208" data-mp="4l894t7gcdlq">
      <nav className="flex w-full items-center justify-between px-6 py-4 md:px-10 lg:px-16" data-id="element-209" data-mp="ejnz2suqtgtn">
        <Link to="/#top" className="flex items-center" data-id="element-210" data-mp="9k1n0mqni6mf">
          <img src="https://cdn.magicpatterns.com/uploads/5PdRrCyrBFpFZN2QamF6sU/medufit_logo_new.png" alt="Medufit" className="h-12 w-48 object-contain object-left mix-blend-multiply sm:w-52" data-id="element-211" data-mp="9mnukmdjkm4n" />
        </Link>

        <div className="hidden items-center gap-9 md:flex" data-id="element-212" data-mp="9nfzgppgniwl">
          {LINKS.map(link => <Link key={link.label} to={link.href} className="text-sm font-medium text-forest/75 transition-colors hover:text-forest" data-id="element-213" data-mp="emj4wb9crr53">
              {link.label}
            </Link>)}
        </div>

        <div className="flex items-center gap-3" data-id="element-214" data-mp="3n3dyf049fz6i">
          <Link to="/#packages" className="hidden rounded-full bg-forest px-5 py-2.5 text-sm font-semibold text-ivory transition-colors hover:bg-forest-deep sm:inline-flex" data-id="element-215" data-mp="3n4p2l11mb8y5">
            Buy Now
          </Link>
          <button onClick={() => setOpen(current => !current)} className="text-forest md:hidden" aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-216" data-mp="5mw1jjx2cb9e">
            {open ? <XIcon className="h-6 w-6" data-id="element-217" data-mp="39bz96bjrf1r0" /> : <MenuIcon className="h-6 w-6" data-id="element-218" data-mp="39axnze914yvk" />}
          </button>
        </div>
      </nav>

      {open && <div className="border-t border-forest/10 bg-ivory px-6 py-5 md:hidden" data-id="element-219" data-mp="31a88hhznov60">
          <div className="flex flex-col gap-4" data-id="element-220" data-mp="2wcyl07vtutkt">
            {LINKS.map(link => <Link key={link.label} to={link.href} onClick={() => setOpen(false)} className="text-base font-medium text-forest/80" data-id="element-221" data-mp="3b0tazgigaju7">
                {link.label}
              </Link>)}
            <Link to="/#packages" onClick={() => setOpen(false)} className="mt-2 rounded-full bg-forest px-5 py-3 text-center text-sm font-semibold text-ivory" data-id="element-222" data-mp="2ie8ksjdpods8">
              Buy Now
            </Link>
          </div>
        </div>}
    </motion.header>;
}